import React from "react";
import classes from "./ImageContainerMobile.module.scss";
import ImageContainerCardMobile from "./ImageContainerCardMobile/ImageContainerCardMobile";
import TrapeziumDivider from "@/components/TrapeziumDivider/TrapeziumDivider";

type Props = {
  data?: any;
  numItemsToShow?: number;
  title?: string;
};
const ImageContainerMobile = ({ data, numItemsToShow=10, title }: Props) => {
  return (
    <div className={classes["trending-news-container"]}>
      <div className={classes["title"]}>{title}</div>
      <TrapeziumDivider customClassName={classes["custom-divider"]} />{" "}
      <div className={classes["all-cards"]}>
        {data?.length > 0 ? (
          data.slice(0, numItemsToShow).map((el: any, index: any, arr: any) => (
            <React.Fragment key={index}>
              <ImageContainerCardMobile news={el} />
              {index + 1 !== arr.length && (index + 1) % 4 === 0 && (
                <hr className={classes["separator"]} />
              )}
            </React.Fragment>
          ))
        ) : (
          <div className={classes["no-data"]}>No news available.</div>
        )}
      </div>
    </div>
  );
};

export default ImageContainerMobile;
